import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mParticleSelectPlacements, canUseMParticle } from './RoktMParticle';
import { RoktPlaceholder } from './Rokt';

class RoktPayment extends Component {
  initialized = false; // run only once when everything is loaded we don't care about next changes to store
  placementSelection = null;

  componentDidUpdate() {
    this.run();
  }

  componentDidMount() {
    this.run();
  }

  componentWillUnmount() {
    this.placementSelection?.close();
  }

  run = async () => {
    const canRun = canUseMParticle();
    if (this.props.data?.attributes && canRun) {
      if (this.initialized) {
        return;
      } else {
        this.initialized = true;
      }
      if (canRun) {
        const { identifier } = this.props.data;
        this.placementSelection = await mParticleSelectPlacements(identifier, { ...this.props.data.attributes });
      }
    }
  }

  render() {
    return <RoktPlaceholder />;
  }
}

const mapStateToProps = (state) => {
  return {
    data: state?.reservation?.roktPayload,
  };
};

export default connect(mapStateToProps)(RoktPayment);
